import React from 'react';
import { node, string, oneOfType, func } from 'prop-types';
import { Sticky, StickyContainer } from 'react-sticky';

const StickyZoneCard = ({ children, className }) => {
  return (
    <StickyContainer style={{ height: '100%' }}>
      <Sticky>
        {({ style }) => {
          return (
            <div style={style} className={className}>{children}</div>
          );
        }}
      </Sticky>
    </StickyContainer>
  );
};

StickyZoneCard.propTypes = {
  children: oneOfType([node, func]),
  className: string,
};

StickyZoneCard.defaultProps = {
  children: null,
  className: 'zone-card',
};

export default StickyZoneCard;
